export const aboutData = {
  brandIntro: {
    title: '关于海角社区视频',
    subtitle: '发现精彩内容，畅享社区视频乐趣',
    description: '海角社区视频成立于2024年，是一个专注于中文视频内容分享与社区互动的平台。我们汇聚了来自全国各地的优质创作者，覆盖娱乐搞笑、音乐舞蹈、美食烹饪、旅行户外、科技数码、体育运动、生活日常、知识科普、游戏电竞等多个领域，致力于为每一位用户提供丰富、有趣、多元的视频内容体验。',
    mission: '让每一个精彩瞬间都被看见，让每一位创作者都能发光。',
    vision: '成为中文互联网最具活力的视频社区平台。',
    values: ['内容为王', '创作者优先', '社区共建', '多元包容', '持续创新'],
    stats: [
      { label: '活跃创作者', value: '50,000+' },
      { label: '日均视频上传', value: '12,000+' },
      { label: '月活跃用户', value: '800万+' },
      { label: '累计视频播放', value: '120亿+' },
    ],
  },
  reputation: {
    title: '用户口碑',
    subtitle: '来自海角社区视频用户的真实评价',
    testimonials: [
      {
        id: 't001',
        name: '小明同学',
        role: '忠实用户 · 加入2年',
        avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20with%20friendly%20smile%20casual%20portrait%2C%20clean%20minimal%20background%2C%20approachable%20look%2C%20soft%20natural%20lighting%2C%20professional%20headshot%20style&width=100&height=100&seq=testimonial-001&orientation=squarish',
        content: '海角社区视频是我每天必刷的平台！内容质量高，推荐算法也很精准，总能看到我感兴趣的视频。而且社区氛围特别好，评论区的互动也很有趣。',
        rating: 5,
      },
      {
        id: 't002',
        name: '小红爱吃货',
        role: '美食创作者 · 加入1年',
        avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20with%20bright%20smile%2C%20warm%20friendly%20portrait%2C%20clean%20background%2C%20happy%20and%20enthusiastic%20look%2C%20soft%20lighting&width=100&height=100&seq=testimonial-002&orientation=squarish',
        content: '作为一名美食创作者，海角社区视频给了我展示厨艺的舞台。平台的流量扶持很给力，我的视频经常能被推荐到首页，粉丝增长也很快。创作者后台的数据分析功能也非常实用！',
        rating: 5,
      },
      {
        id: 't003',
        name: '老王爱科技',
        role: '科技爱好者 · 加入8个月',
        avatar: 'https://readdy.ai/api/search-image?query=Chinese%20middle-aged%20man%20with%20glasses%20and%20friendly%20smile%2C%20professional%20portrait%2C%20clean%20background%2C%20approachable%20tech%20enthusiast%20look%2C%20soft%20studio%20lighting&width=100&height=100&seq=testimonial-003&orientation=squarish',
        content: '海角社区视频的科技频道内容非常专业，很多数码测评都是深度体验后的真实分享，不像其他平台全是广告。在这里学到了很多数码知识，也交到了志同道合的朋友。',
        rating: 4,
      },
      {
        id: 't004',
        name: '旅行青蛙',
        role: '旅行博主 · 加入1.5年',
        avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20female%20traveler%20with%20adventurous%20spirit%2C%20outdoor%20portrait%20with%20warm%20natural%20light%2C%20friendly%20and%20free-spirited%20look%2C%20clean%20background&width=100&height=100&seq=testimonial-004&orientation=squarish',
        content: '海角社区视频的旅行频道真的是宝藏！很多小众旅行地的攻略都是在海角社区视频发现的。而且视频画质很高清，看着就像自己也去旅行了一样。强烈推荐给所有爱旅行的朋友！',
        rating: 5,
      },
    ],
  },
  contact: {
    title: '联系我们',
    subtitle: '有任何问题或建议？我们随时欢迎你的来信',
    email: 'contact@haijiaoshipin.com',
    phone: '400-888-6666',
    address: '北京市朝阳区望京科技园A座15层',
    workingHours: '周一至周五 9:00 - 18:00',
    socialLinks: [
      { name: '微博', icon: 'ri-weibo-line', url: 'https://weibo.com/haijiaoshipin' },
      { name: '微信公众号', icon: 'ri-wechat-line', url: '#' },
      { name: 'B站', icon: 'ri-bilibili-line', url: 'https://space.bilibili.com/haijiaoshipin' },
      { name: '抖音', icon: 'ri-tiktok-line', url: '#' },
    ],
  },
};

export const faqData = [
  {
    question: '海角社区视频是什么？',
    answer: '海角社区视频是一个专注于中文视频内容分享与社区互动的平台。我们汇聚了来自全国各地的优质创作者，覆盖娱乐、音乐、美食、旅行、科技、体育、生活、知识、游戏等多个领域，为用户提供丰富多元的视频内容体验。',
  },
  {
    question: '如何成为海角社区视频的创作者？',
    answer: '在海角社区视频平台注册账号后，点击右上角的「创作中心」即可开始上传你的第一个视频。我们为新创作者提供流量扶持和创作指导，帮助你快速成长。创作达到一定等级后还可以开通收益功能。',
  },
  {
    question: '海角社区视频的内容审核标准是什么？',
    answer: '我们严格遵循国家法律法规和社区规范，对上传内容进行AI+人工双重审核。禁止发布违法违规、低俗暴力、侵犯他人权益等内容。我们致力于为用户营造一个健康、积极、友善的视频社区环境。',
  },
  {
    question: '在海角社区视频平台上观看视频需要付费吗？',
    answer: '海角社区视频平台上绝大多数内容都是免费观看的。部分创作者可能会发布少量付费精品内容，但平台的核心内容始终保持免费，让每一位用户都能畅享社区视频乐趣。',
  },
  {
    question: '如何联系海角社区视频的客服？',
    answer: '你可以通过以下方式联系我们：发送邮件至 contact@haijiaoshipin.com，或在工作时间拨打客服电话 400-888-6666。也可以在海角社区视频 App 内的「我的-帮助与反馈」中找到在线客服入口。',
  },
];